import React, { useEffect, useState } from "react"
import { Row, Col } from "react-bootstrap"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"
import {
  updateUiData,
  updateValidFormData,
  getRequiredDocuments,
  getPolicyInfo,
  getBankListData,
  updateDropdown,
} from "../redux/actions"
import {
  navigateToClaimantDetail,
  backMaxPage,
  navigateToError,
} from "../common/function"
import FormDropdownArray from "../components/shared/formDropdownArray"
import FormTextbox from "../components/shared/formTextbox"
import FormFieldDisableAutoComplete from "../components/shared/formFieldDisableAutoComplete"
import FormAmountTextBox from "../components/shared/formAmountTextBox"
import FormDateInputTextbox from "../components/shared/formDateInputTextbox"
import FormTimeTextBox from "../components/shared/formTimeTextBox"
import FormDatePickerTextBox from "../components/shared/formDatePickerTextBox"

// import * as Regex from "../common/regex"
import * as ErrorMessage from "../common/errorMessage"
import * as Constants from "../common/constants"
import {
  missingInfoAlert,
  commonErrorAlert,
} from "../services/sweetalertService"
import * as API from "../services/httpService"
import { navigate } from "gatsby"
import * as CommonFunction from "../common/function"
import * as Regex from "../common/regex"
import { isValid, parse } from "date-fns"

const Index = ({ location }) => {
  const uiData = useSelector(state => state.uiData, shallowEqual)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const bankList = useSelector(state => state.uiData.bankList, shallowEqual)
  const dropdownData = useSelector(state => state.dropdownData, shallowEqual)
  const dispatch = useDispatch()
  const formRef = React.useRef()
  const incidentList = useSelector(
    state => state.uiData.incidentList,
    shallowEqual
  )
  const { Gender } = dropdownData

  const convertMsToDays = ms => {
    const msInOneSecond = 1000
    const secondsInOneMinute = 60
    const minutesInOneHour = 60
    const hoursInOneDay = 24

    const minutesInOneDay = hoursInOneDay * minutesInOneHour
    const secondsInOneDay = secondsInOneMinute * minutesInOneDay
    const msInOneDay = msInOneSecond * secondsInOneDay

    return Math.ceil(ms / msInOneDay)
  }

  const getDaysBetweenDates = (dateOne, dateTwo) => {
    let differenceInMs = dateTwo.getTime() - dateOne.getTime()

    if (differenceInMs < 0) {
      differenceInMs = dateOne.getTime() - dateTwo.getTime()
    }
    return convertMsToDays(differenceInMs)
  }

  useEffect(() => {
    if (uiData.maxPageNumber === 1) {
      const GetDataPromise = API.apiPostRequest("/Claim/GetData", null, null)

      Promise.all([GetDataPromise])
        .then(values => {
          batch(() => {
            //Check if not from iConnect
            // if (
            //   process.env.NODE_ENV !== "development" &&
            //   (!values[0].data.sourceSystem ||
            //     values[0].data.sourceSystem.toLowerCase() != "b2b")
            // ) {
            //   API.apiPostRequest("/Claim/GetIConnectURL", null, null)
            //     .then(values => {
            //       //If can get iConnect URL auto redirect to iConnect
            //       if (values.data) {
            //         window.onbeforeunload = {}
            //         window.location.href = values.data
            //       } else {
            //         //If cannot get iConnect URL show an alert
            //         commonErrorAlert("Please make claim from iConnect Portal")
            //         dispatch(updateUiData("showLoading", false))
            //       }
            //     })
            //     .catch(error => {
            //       navigate("errorOccurred")
            //     })
            // } else {
              //Process from iConnect
              if (values[0].data.sourceSystem) {
                dispatch(
                  updateValidFormData(
                    "petClaimHeaderModel",
                    values[0].data
                  )
                )
              }

              dispatch(getBankListData())
              // Changed to text field already
              // dispatch(getDropdownData(Constants.gigacoverDamageDescTableName))
              dispatch(updateUiData("showLoading", false))

              const GetGenderTableNamePromise = API.apiPostRequest(
                "/Claim/CommonDropDownList",
                null,
                {
                  params: {
                    name: Constants.genderTableName,
                  },
                }
              )
              
              Promise.all([GetGenderTableNamePromise])
                .then(promiseValues => {
                  batch(() => {
                    if (promiseValues[0].data) {
                      dispatch(
                        updateDropdown(
                          promiseValues[0].data.TableName,
                          promiseValues[0].data.CodeTables
                        )
                      )
                    }
                  })
                })
                .catch(error => {
                  navigateToError()
                })
            //}
          })
        })
        .catch(error => {
          navigate("errorOccurred")
        })
    } else {
      // Delete all uploaded file
      if (uiData.claimUploadListModel.length > 0) {
        let deleteMultipleFileArray = []

        uiData.claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
          let deleteFileInfo = {}
          deleteFileInfo.fName = UploadedItem.fileName
          deleteFileInfo.folderName = uiData.folderName
          deleteMultipleFileArray.push(deleteFileInfo)
        })

        API.apiPostRequest(
          "/Claim/ClaimDocsMultipleDelete",
          deleteMultipleFileArray,
          null
        ).then(response => {
          dispatch(updateUiData("claimUploadListModel", []))
        })
      }
      dispatch(updateUiData("showLoading", false))
    }

    CommonFunction.updateUiCurrentPageNumber(dispatch, location.href)
  }, [])

  const formikSchema = Yup.object().shape({
    claimantName: Yup.string()
    .required(ErrorMessage.claimantName)
    .matches(Regex.namepattern, ErrorMessage.claimantName),
    claimantNricNumber: Yup.string()
      .required(ErrorMessage.claimantNricNumber)
      .matches(Regex.nricpattern, ErrorMessage.claimantNricNumber),
    policyNumber: Yup.string()
      .required(ErrorMessage.policyNumber)
      .matches(Regex.policyPattern, ErrorMessage.policyNumber),
    claimantMobile: Yup.string()
      .required(ErrorMessage.claimantMobile)
      .matches(Regex.mobilepattern, ErrorMessage.claimantMobile),
    claimantEmail: Yup.string().email(ErrorMessage.claimantEmail),
  })

  const generateFolderName = draftFolderPrefix => {
    let dd = new Date()
    let ss =
      "" +
      dd.getYear() +
      dd.getMonth() +
      dd.getDate() +
      dd.getHours() +
      dd.getMinutes() +
      dd.getSeconds()
    return draftFolderPrefix + ss
  }

  return (
    <Formik
      initialValues={Object.assign({}, claimData["petClaimHeaderModel"])}
      enableReinitialize={true}
      validationSchema={formikSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {
        dispatch(updateUiData("showLoading", true))

        dispatch(updateValidFormData("petClaimHeaderModel", values))
        dispatch(getRequiredDocuments(Constants.basicCoverageDetailId))

        const sessionIdAndFolderName = generateFolderName(
          uiData.draftFolderPrefix
        )
        dispatch(updateUiData("folderName", sessionIdAndFolderName))

        const getPolicyInfoRequestModel = {
          PolicyNumber: values.policyNumber,
          PolicyHolderName: values.claimantName,
        }

        dispatch(getPolicyInfo(getPolicyInfoRequestModel))
      }}
    >
      {({ handleSubmit, isSubmitting, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row>
            <div className="title text-center">
              {uiData.claimFormTitle} eClaim
            </div>
            <div className={"containerBody"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="marginBottom16px marginTop30px">
                  <div className={"titleText "}>Policyholder Information</div>
                </div>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox topFieldBox mt-3"
                >
                  <Field
                    textDesc="Name of Policyholder"
                    maxLength={100}
                    name="claimantName"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc="NRIC/FIN No"
                    maxLength={10}
                    name="claimantNricNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Policy Number"
                    maxLength={8}
                    name="policyNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc="Email Address"
                    maxLength={100}
                    name="claimantEmail"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc="Contact No"
                    maxLength={20}
                    name="claimantMobile"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                </Col>
              </Col>
            </div>
          </Row>
          <Row>
            <div className="submitFormCenterBtnDiv">
              <button
                className="btnSubmitForm fontWeightBold"
                type="submit"
                // disabled={isSubmitting}
              >
                <b>Next</b>
              </button>
            </div>
          </Row>
          <HandleFormSubmit formRef={formRef} isSubmitting={isSubmitting} />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormSubmit = ({ formRef, isSubmitting}) => {
  React.useEffect(() => {
    if (isSubmitting) {
      formRef.current.setSubmitting(true)
      formRef.current.validateForm().then(errors => {
        if (Object.entries(errors).length !== 0) {
          console.log("C")
          missingInfoAlert()
        }
      })
      formRef.current.setSubmitting(false)
    }
  }, [isSubmitting])
  return null
}

export default Index
